import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=5bda5ac9&scoped=true"
import script from "./Rewards.vue?vue&type=script&lang=js"
export * from "./Rewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda5ac9",
  null
  
)

export default component.exports